export const endpoints = {
  CONTACT: '/api/contact',
  CONTACT_PERSON: '/api/contact/:id',
};
